import axios from "axios";

export const onlineURL = "https://hiro-health.sy/cms/api";
// export const onlineURL = "http://localhost:8000/api";
const API_url = process.env.VUE_APP_API_URL;

export const instance = axios.create({
  baseURL: `${onlineURL}/patient`,
});

export const onlineDataSource = axios.create({
  baseURL: `${onlineURL}/patient`,
});

if (localStorage.getItem("user")) {
  instance.defaults.headers.common["Authorization"] = `Bearer ${
    JSON.parse(localStorage.getItem("user")).token
  }`;
}
